import classes from './SearchPanel.module.css';
import * as React from 'react';
import SearchInput from './SearchInput';

type SearchPanelProps = {
  isOpen: boolean;
  onSelect: React.ComponentProps<typeof SearchInput>['onSelect'];
  onClose: () => void;
};

const SearchPanel = ({
  isOpen,
  onSelect,
  onClose,
}: SearchPanelProps) => {
  const panelRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (isOpen) {
      panelRef.current?.classList.add(classes.open);
    } else {
      panelRef.current?.classList.remove(classes.open);
    }
  }, [isOpen]);

  return (
    <div
      ref={panelRef}
      className={`absolute w-full left-0 top-full bg-white shadow-xl border-t p-4 ${classes['panel']}`}
    >
      <SearchInput
        onSelect={onSelect}
        onClear={onClose}
      />
    </div>
  );
}

export default SearchPanel;
